// 首页相关api
import request from '../index'

/**
 * 获取商品列表
 * @returns 
 */
export const getGoodsList = (data) => {
  return request({
    url: '/goods/info/',
    method: 'get',
    params: data
  });
}
/**
 * 获取订阅计划列表
 * @returns 
 */
export const queryPlanList = (data) => {
  return request({
    url: '/goods/info/queryPlanList/'+data,
    method: 'get',
  });
}
/**
 * 创建订单
 * @returns 
 */
export const createOrder = (data) =>{
  return request({
    url: '/order/info/create',
    method: 'post',
    data
  });
}
/**
 * 支付结果通知
 * @returns 
 */
export const payOrderNotify = (data) =>{
  return request({
    url: '/order/info/payNotify',
    method: 'post',
    data
  });
}
/**
 * 获取Airwallex账户信息
 * @returns 
 */
export const getAirwallex = (data) => {
  return request({
    url: '/user/info/airwallex',
    method: 'get',
  });
}
/**
 * 新增Airwallex付款同意书记录
 * @returns 
 */
export const addPayConsent = (data) =>{
  return request({
    url: '/app/airwallex/pay/consent/',
    method: 'post',
    data
  });
}